import { render } from "./2022-10-19-ES6 Data Type.md?vue&type=template&id=63205dce"
const script = {}
script.render = render

export default script